var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_1785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1333 48.9999L45.7333 65.3333L71.8666 32.6666M48.9999 94.7333C42.9941 94.7333 37.0472 93.5503 31.4985 91.252C25.9499 88.9537 20.9083 85.585 16.6616 81.3383C12.4149 77.0915 9.04616 72.0499 6.74784 66.5013C4.44953 60.9527 3.2666 55.0057 3.2666 48.9999C3.2666 42.9941 4.44953 37.0472 6.74784 31.4985C9.04616 25.9499 12.4149 20.9083 16.6616 16.6616C20.9083 12.4149 25.9499 9.04616 31.4985 6.74784C37.0472 4.44953 42.9941 3.2666 48.9999 3.2666C61.1292 3.2666 72.7616 8.08492 81.3383 16.6616C89.9149 25.2382 94.7333 36.8707 94.7333 48.9999C94.7333 61.1292 89.9149 72.7616 81.3383 81.3383C72.7616 89.9149 61.1292 94.7333 48.9999 94.7333Z",
    stroke: "#12B85E",
    strokeWidth: 6.53333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_1785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.590ab2f93c066042a36641eb43dc1f8a.svg";
export { ForwardRef as ReactComponent };